"use client";

import React, { useEffect } from "react";
import Link from "next/link";
import { SocialLink } from "@/.storyblok/types/319751/storyblok-components";

interface SocialProps {
  color?: string;
  social_links?: SocialLink[];
}

const SocialComponent: React.FC<SocialProps> = ({
  color = "white",
  social_links = [],
}) => {
  const socialPlatformMap: Record<string, { icon: string; title: string }> = {
    facebook: {
      icon: "fab fa-facebook-f",
      title: "Follow us on Facebook",
    },
    linkedin: {
      icon: "fab fa-linkedin",
      title: "Follow us on LinkedIn",
    },
    twitter: {
      icon: "fab fa-x-twitter",
      title: "Follow us on Twitter",
    },
    youtube: {
      icon: "fab fa-youtube",
      title: "Watch us on YouTube",
    },
  };

  useEffect(() => {
    let tooltips: any[] = [];

    const initTooltips = async () => {
      if (typeof window !== "undefined") {
        try {
          const bootstrap = (await import("bootstrap")).default || (await import("bootstrap"));

          if (bootstrap?.Tooltip) {
            const tooltipTriggerList = document.querySelectorAll("[data-bs-toggle='tooltip']");

            tooltips = Array.from(tooltipTriggerList).map(
              (tooltipTriggerEl) =>
                new bootstrap.Tooltip(tooltipTriggerEl, {
                  trigger: "hover",
                  placement: "top",
                })
            );
          } else {
            console.warn("Bootstrap Tooltip is not available.");
          }
        } catch (error) {
          console.error("Error initializing tooltips:", error);
        }
      }
    };

    initTooltips();

    return () => {
      tooltips.forEach((tooltip) => {
        if (tooltip && typeof tooltip.dispose === "function") {
          tooltip.dispose();
        }
      });
    };
  }, [social_links]);

  return (
    <ul className="component component-social list-unstyled list-inline mb-0 d-inline-block text-nowrap">
      {social_links.map((socialLink) => {
        const platform = socialLink.platform?.toLowerCase();
        if (
          !platform ||
          !socialPlatformMap[platform] ||
          !socialLink.url?.cached_url
        ) {
          return null;
        }

        return (
          <li key={socialLink._uid} className="me-1">
            <Link
              href={socialLink.url.cached_url}
              target="_blank"
              rel="noopener"
              data-bs-toggle="tooltip"
              title={socialPlatformMap[platform].title}
            >
              <i
                className={`${socialPlatformMap[platform].icon} fa-lg link-${platform} text-${color}`}
              />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialComponent;